module.exports = __webpack_public_path__ + "assets/img/k12_login_icon.222120ed.png";